module.exports = __webpack_public_path__ + "static/Group_135_Copy-6ad9195a8121302158df428d114246a0.png";